module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "salesReport"
  }, [_vm._v("\n    ====================》这是salesReport页\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a0b4398","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/report/salesReport.vue
// module id = 1164
// module chunks = 1